module.exports = __webpack_public_path__ + "static/media/bitcoingreen.32a6de6a.svg";